import { render, staticRenderFns } from "./item-view.vue?vue&type=template&id=2db4a4ee&"
import script from "./item-view.vue?vue&type=script&lang=js&"
export * from "./item-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports